var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 15914"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 28,
    cy: 28,
    r: 25,
    fill: "#6C6C6C",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 52",
    d: "M14.5 34.5L42 34.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 18",
    d: "M37.5 27L37.5 26.05C37.5 23.8132 35.933 22 34 22C32.067 22 30.5 23.8132 30.5 26.05L30.5 27",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 19",
    d: "M26 27L26 26.05C26 23.8132 24.433 22 22.5 22C20.567 22 19 23.8132 19 26.05L19 27",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 20",
    d: "M42.009 15.378C42.1908 15.7799 42.386 16.2201 42.581 16.6746C42.9516 17.5386 43.3159 18.4412 43.5856 19.2255C43.8718 20.0574 44 20.6149 44 20.8571C44 22.0793 43.0598 23 42 23C40.9711 23 40 21.9551 40 20.8571C40 20.789 40.0212 20.6169 40.098 20.315C40.1705 20.0301 40.278 19.6847 40.4135 19.2944C40.6841 18.5147 41.0493 17.6049 41.4206 16.7298C41.6215 16.2564 41.8225 15.7967 42.009 15.378Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress);
export default __webpack_public_path__ + "static/media/Stress.776bdd1e304258fa34e9140859c720be.svg";
export { ForwardRef as ReactComponent };